import { getAssessmentDetail2, startAssessment, updateLaunchedAttempt, populateAttemptReport,
	startLearningActivity, continueLearningActivity, stopLearningActivity, saveRating,
	getToolProxies, scormLaunchURL, getKCMessage, getKCDescription, getRichHtmlAssessment,
  getScormDetails,scormLaunchURLWithToken, getDiagnosticTestReport} from '../api'

export const loadAssessment2 = ({ state, commit }, uuid) => {
  return getAssessmentDetail2(uuid)
}

export const launchAssessment = ({ state, commit }, { uuid, courseId, sessionId }) => {
  return startAssessment(uuid, courseId, sessionId)
}

export const updateAttempt = ({ state, commit }, { sessionId, externalId, isFinished }) => {
  return updateLaunchedAttempt(sessionId, externalId, isFinished)
}

export const showAttemptReport = ({ state, commit }, { activityId, sessionId, courseId }) => {
  return populateAttemptReport(activityId, sessionId, courseId)
}

export const startActivity = ({ state, commit }, activity) => {
  return startLearningActivity(activity)
}

export const continueActivity = ({ state, commit }, activity) => {
  return continueLearningActivity(activity)
}
export const loadRichHtmlAssessment = ({state, commit}, ancestor) => {
  return getRichHtmlAssessment(ancestor)
}
export const stopActivity = ({ state, commit }, activity) => {
  return stopLearningActivity(activity)
}

export const storeRating = ({ state, commit }, ratingInfo) => {
  return saveRating(ratingInfo)
}

export const loadToolProxies = ({ state, commit }, uuid) => {
  return getToolProxies(uuid)
}
export const loadScormDetail = ({ state, commit }, { entityUuid,token }) => {
    return getScormDetails(entityUuid, token).then((res) => {
      return res
    })
}

export const loadScormLaunchURL = ({ state, commit }, entity) => {
  return scormLaunchURL(entity)
}
export const getScormLaunchURLWithToken = ({ state, commit }, entity) => {
  return scormLaunchURLWithToken(entity).then((res) => {
    return res
  })
}

export const loadKCMessage = ({ state, commit }, {entityId, courseType} ) => {
  return getKCMessage(entityId, courseType)
}

export const loadKCDescription = ({ state, commit }, { entityId, courseType, courseId }) => {
  return getKCDescription(entityId, courseType, courseId)
}

export const loadDiagnosticTestReport = ({ state, commit }, {courseId, assessmentId}) => {
  return getDiagnosticTestReport(courseId, assessmentId)
}



// WEBPACK FOOTER //
// ./src/app/assessment/vuex/actions.js